import { useEffect, useState } from 'react'
import Lightbox from '~/components/shared-components/Lightbox/Lightbox'

interface LightboxWithHtmlProps {
  formname?: string
  handleClose?: () => void
}

function LightboxWithHtml(props: LightboxWithHtmlProps) {
  const [html, setHtml] = useState('')

  useEffect(() => {
    fetch(`/html/${props.formname || 'form'}.html`)
      .then(res => res.text())
      .then(data => setHtml(data))
  }, [props.formname])

  return (
    <Lightbox style={{ width: '80%' }} onClose={props.handleClose}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </Lightbox>
  )
}

export default LightboxWithHtml
